import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["typeSelect", "keywordField", "patternField", "scriptField"];

  connect() {
    this.toggleFields();
  }

  toggleFields() {
    const type = this.typeSelectTarget.value;
    
    // Hide all first
    this.keywordFieldTarget.classList.add("hidden");
    this.patternFieldTarget.classList.add("hidden");
    this.scriptFieldTarget.classList.add("hidden");

    // Show based on type
    if (type === "keyword" || type === "prohibited_phrase") {
      this.keywordFieldTarget.classList.remove("hidden");
    } else if (type === "pattern") {
      this.patternFieldTarget.classList.remove("hidden");
    } else if (type === "script_required") {
      this.scriptFieldTarget.classList.remove("hidden");
    } else if (type === "escalation_required") {
      this.scriptFieldTarget.classList.remove("hidden");
      this.keywordFieldTarget.classList.remove("hidden");
    } else if (type === "semantic") {
      // Semantic might not need extra fields or might need description
    }
  }
}
